enum LinkedInactiveType {
    NoFilterValue = 1, /* This value needs other record values to be filtered */
    UsedByOther = 2 /* This value is used by other linked field to be filtered */
}

export default LinkedInactiveType;